const UsageTypeInputIcon = ({ size = 56, className = "", isActive = false, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      {isActive ? (
        <>
          <circle cx="28" cy="28" r="27" fill="#68D7FF" fillOpacity="0.2" />
          <circle cx="28" cy="28" r="27" stroke="url(#blueGradient)" strokeWidth="2" />
        </>
      ) : (
        <>
          <rect x="1" y="1" width="54" height="54" rx="27" fill="#9EA6B2" fillOpacity="0.3" />
          <rect x="1" y="1" width="54" height="54" rx="27" stroke="url(#grayGradient)" strokeWidth="2" />
        </>
      )}

      {/* Shared icon paths */}
      <path
        d="M38.6934 27.7715C38.6934 27.3364 38.5205 26.9191 38.2128 26.6114C37.9052 26.3037 37.4879 26.1309 37.0527 26.1309H36.1645C35.3676 29.8237 32.0746 32.5996 28.1488 32.5996C24.223 32.5996 20.9277 29.8237 20.1309 26.1309H19.2402C18.8051 26.1309 18.3878 26.3037 18.0801 26.6114C17.7725 26.9191 17.5996 27.3364 17.5996 27.7715V34.4434C17.5996 35.5479 18.495 36.4434 19.5996 36.4434H36.6934C37.7979 36.4434 38.6934 35.5479 38.6934 34.4434V27.7715Z"
        fill={isActive ? "#01BBFE" : "white"}
      />
      <path
        d="M28.1465 31.1934C31.8965 31.1934 34.9434 28.1465 34.9434 24.3965C34.9434 20.6465 31.8965 17.5996 28.1465 17.5996C24.3965 17.5996 21.3496 20.6488 21.3496 24.3965C21.3496 28.1441 24.3988 31.1934 28.1465 31.1934ZM24.8765 23.3938C25.0181 23.2725 25.2021 23.2124 25.388 23.2267C25.5739 23.241 25.7466 23.3286 25.8679 23.4702L27.4434 25.3082V21.584C27.4434 21.3975 27.5174 21.2187 27.6493 21.0868C27.7812 20.9549 27.96 20.8809 28.1465 20.8809C28.333 20.8809 28.5118 20.9549 28.6437 21.0868C28.7755 21.2187 28.8496 21.3975 28.8496 21.584V25.3082L30.4251 23.4702C30.5468 23.3301 30.7191 23.2438 30.9042 23.2301C31.0894 23.2165 31.2724 23.2766 31.4134 23.3974C31.5544 23.5182 31.6419 23.6899 31.6567 23.8749C31.6716 24.06 31.6127 24.2434 31.4929 24.3852L28.6804 27.6665C28.6144 27.7435 28.5325 27.8053 28.4403 27.8477C28.3482 27.8901 28.2479 27.9121 28.1465 27.9121C28.045 27.9121 27.9448 27.8901 27.8526 27.8477C27.7605 27.8053 27.6786 27.7435 27.6126 27.6665L24.8001 24.3852C24.6787 24.2436 24.6186 24.0596 24.633 23.8737C24.6473 23.6878 24.7349 23.5152 24.8765 23.3938Z"
        fill={isActive ? "#01BBFE" : "white"}
      />

      <defs>
        <linearGradient id="grayGradient" x1="3.95" y1="4.4" x2="50.76" y2="54.45" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="blueGradient" x1="3.95" y1="4.4" x2="50.76" y2="54.45" gradientUnits="userSpaceOnUse">
          <stop stopColor="#68D7FF" />
          <stop offset="1" stopColor="#68D7FF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default UsageTypeInputIcon;
